import { Service, ServiceOptions } from "../client/service";
import { Container } from "./container";

export class ServiceCollectionEvent extends Event {
	service: Service;
	constructor(type: string, service: Service) {
		super(type);
		this.service = service;
	}
}

export class ServiceCollection extends EventTarget {

	#items: Map<string, Service> = new Map();
	#container: Container;

	get items() { return this.#items }

	constructor(container: Container) {
		super();
		this.#container = container;
	}

	register(service: Service|string, options?: Partial<ServiceOptions>) {
		service = service instanceof Service ? service : new Service(Object.assign({
			name: service as string
		}, this.#container.options.defaultServiceOptions, options) as ServiceOptions);
		this.#items.set(service.name, service);
		service.container = this.#container;
		service.accountingProvider = this.#container.accountingProvider;
		service.userProvider = this.#container.userProvider;
		this.dispatchEvent(new ServiceCollectionEvent('register', service));
		return service;
	}

	unregister(name: string) {
		this.#items.delete(name);
		this.dispatchEvent(new ServiceCollectionEvent('unregister', null));
	}

	get(name: string) {
		return this.#items.get(name);
	}

	forEach(callback: (service: Service) => void) {
		this.#items.forEach(callback);
	}

}
